import * as React from "react";
const SvgMinusNoFill = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 11H18V13H6V11Z" }));
export default SvgMinusNoFill;
